// 観察記録の入力欄の部品

// react moment
import * as React from 'react';
// material-ui
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { Typography } from '@material-ui/core';
// CSS
import './InferenceResultView.css';
// models
import { KansatsuKirokuObsrec } from '../../models/KansatsuKirokuObsrec';
import { InferenceResultObsrec } from '../../models/InferenceResultObsrec';
import { InferenceAdditionalResultObsrec } from '../../models/InferenceAdditionalResultObsrec';

const styles = {
  valueField: {
    width: '150px',
    marginRight: '5px'
  },
  rowDark: {
    fontSize: '15px',
    backgroundColor: '#3f51b514',
    padding: '0px',
    textAlign: "center" as "center"
  },
  rowLight: {
    fontSize: '15px',
    padding: '0px',
    textAlign: "center" as "center"
  },
};

interface OwnProps {
  disabled: boolean;
  data: KansatsuKirokuObsrec['observationsScores'];
  // trueの場合ボタンを非表示にする（主に印刷時）
  // hideButtons?: boolean;
  lineNum: number;
  columnNum: number;
  observationNames: string[];
  observationDescriptions: string[]

  result: InferenceResultObsrec[];
  // 結果表を非表示にする（主に印刷用）
  hideTable?: boolean;
  // 画像を非表示にする（主に印刷用）
  hideImages?: boolean;
  // 印刷時の描写か（主に印刷用）未指定の場合は undefined となり、判定では false つまりデフォルト値は false
  isPrint?: boolean;
  cropImageWidth: number;

  // 評価値確定がステップルールの場合に必要な要素
  targetStepRuleObservationNames?: string[];
  // 評価値確定が最頻値ルールの場合に必要な要素
  targetModeRuleObservationNames?: string[];
  // 評価値確定が平均<スコア重複排除前提>ルールの場合に必要な要素
  targetMeanDeduplicationRuleObservationNames?: string[];
  // 評価値確定が平均<一般>ルールの場合に必要な要素
  targetMeanGeneralRuleObservationNames?: string[];
  topBadsideSize?: number;
  leftBadsideSize?: number;
  rightBadsideSize?: number;

}
interface OwnState {
  // 入力項目に対するState 「KansatsuKirokuObsrec['observationsScores']」と同じ型
  observationsScores: Array<{
    observation: string; // 観察項目
    scores: Array<{
      position: string; // 位置（左上から右方向でカウントしたときの位置）
      score: string; // スコア
    }>;
  }>
  resultHuman: InferenceResultObsrec[]; // 人判断のresult(人判断の総合評価用)
  additionalResultHuman: InferenceAdditionalResultObsrec; // 人判断のadditionalResult(人判断の総合評価用)
}
class KansatsuKirokuScoreEditForObsrec extends React.Component<OwnProps, OwnState>{
  constructor(props) {
    super(props);
    this.state = {
      observationsScores: [],
      resultHuman: [],
      additionalResultHuman: {
        each_position_score: { left: 0, top: 0, right: 0 },
        each_position_weight: { left: 0, top: 0, right: 0 },
        finally_score: 0
      },
    };
  }

  componentWillReceiveProps(newProps: OwnProps) {
    type posScoreType = {
      position: string,
      score: string
    }
    type obsElementType = {
      observation: string,
      scores: posScoreType[]
    }
    // 観察項目分、細分化されたエリアの配列を作成する
    const observationsScoresInitialScore: obsElementType[] = []
    if (!newProps.data || newProps.data.length === 0 || !newProps.lineNum || !newProps.columnNum) {
      for (const obsName of newProps.observationNames) {
        const obsElement: obsElementType = { observation: obsName, scores: [] }
        for (let i2 = 0; i2 < newProps.lineNum; i2++) {
          for (let i3 = 0; i3 < newProps.columnNum; i3++) {
            const positionStr: string = String(i2 + 1) + '-' + String(i3 + 1);
            obsElement.scores.push({ position: positionStr, score: '0' });
          }
        }
        observationsScoresInitialScore.push(obsElement);
      }
    }
    this.setState({
      observationsScores: newProps.data || observationsScoresInitialScore
    })

    // 人判断の総合評価表の骨子を作成
    const resutHumanInitial: InferenceResultObsrec[] = []
    this.setState({
      resultHuman: resutHumanInitial
    });

    if (this.state.observationsScores.length !== 0) {
      this.changeComprehensiveEvaluationTable();
    }
  }

  getSum(list: any[]): number {
    let sum = 0;
    list.forEach((elm) => {
      sum += elm;
    });
    return sum;
  };

  getMean(list: any[]): number {
    const listExcZero = list.filter(item => item > 0);
    return this.getSum(listExcZero) / listExcZero.length;
  };

  getMode(list: any[]): number {
    if (list.length === 0) { // 配列の個数が0だとエラーを返す。
      // throw new Error("配列の長さが0のため最頻値が計算できません");
      return 0 // nullを返しても困らない時(配列の中にnullが無い時)はnullを返すように実装しても良い。
    }
    const counter = {} // 回数を記録する連想配列
    const nativeValues = {} // 本来の値を入れた辞書
    // 最頻値とその出現回数を挿入する変数
    let maxCounter = 0;
    let maxValue = 0;
    for (const item of list) {
      if (!counter[item + "_" + typeof item]) { // counterに存在しなければ作る。keyは型を区別する
        counter[item + "_" + typeof item] = 0;
      }
      counter[item + "_" + typeof item]++;
      nativeValues[item + "_" + typeof item] = item;
    }
    // 最頻値が同数であれば大きい数字を採用
    let counterTmp = Object.keys(counter).map((k) => ({ key: k, value: counter[k] }));
    let nativeValuesTep = Object.keys(nativeValues).map((k) => ({ key: k, value: nativeValues[k] }));
    counterTmp = counterTmp.sort((a: any, b: any) => a.key > b.key ? 1 : -1);
    nativeValuesTep = nativeValuesTep.sort((a: any, b: any) => a.key > b.key ? 1 : -1);

    const counter2 = Object.assign({}, ...counterTmp.map((item) => ({ [item.key]: item.value })));
    const nativeValues2 = Object.assign({}, ...nativeValuesTep.map((item) => ({ [item.key]: item.value })));
    for (const key of Object.keys(counter2)) {
      if (counter2[key] >= maxCounter) { // 最頻値が同数の場合に小さい数値を優先する場合は > 、大きい数値を優先する場合は >=
        maxCounter = counter2[key];
        maxValue = nativeValues2[key]
      }
    }
    return maxValue
  }

  getStepRuleScore(list: any[], badsideSize: any): number {
    const deduplicationList = Array.from(new Set(list));
    if(!badsideSize){
      // return Math.round(10 * this.getMean(list)) / 10
      // return Math.round(this.getMean(list))
      return Math.round(this.getMean(deduplicationList))
    }
    const tmpList = list.filter(item => item > 0); // 該当領域のスコア群から0を除外する
    const maxScore = Math.max(...tmpList)
    const maxScoreCount = tmpList.filter(n => n === maxScore).length;
    if (maxScoreCount >= badsideSize){
      return maxScore
    }else{
      // return Math.round(10 * this.getMean(list)) / 10
      // return Math.round(this.getMean(list))
      return Math.round(this.getMean(deduplicationList))
    }
  }

  getMeanDeduplicationRuleScore(list: any[]): number {
    const deduplicationList = Array.from(new Set(list));
    return Math.round(this.getMean(deduplicationList))
  }
  getMeanGeneralRuleScore(list: any[]): number {
    return Math.round(this.getMean(list))
  }

  changeComprehensiveEvaluationTable() { // 人判断の総合評価表の更新
    if (this.props.result) {
      let resultHumanTmp: InferenceResultObsrec[] = []
      resultHumanTmp = JSON.parse(JSON.stringify(this.props.result)) // 最下層まで複製
      const obsNums: number[] = []
      for (const key of Object.keys(resultHumanTmp)) {
        obsNums.push(parseInt(key, 10))
      }

      // 天端のリストを作成
      const topPositionList: string[] = []
      for (let rowNum = 0; rowNum < this.props.lineNum / 2; rowNum++) {
        for (let colNum = 0; colNum < this.props.columnNum; colNum++) {
          const positionStr = String(Number(rowNum + 1)) + '-' + String(Number(colNum + 1))
          topPositionList.push(positionStr)
        }
      }
      // 左肩のリストを作成
      const leftPositionList: string[] = []
      for (let rowNum = this.props.lineNum / 2; rowNum < this.props.lineNum; rowNum++) {
        for (let colNum = 0; colNum < this.props.columnNum / 2; colNum++) {
          const positionStr = String(Number(rowNum + 1)) + '-' + String(Number(colNum + 1))
          leftPositionList.push(positionStr)
        }
      }
      // 右肩のリストを作成
      const rightPositionList: string[] = []
      for (let rowNum = this.props.lineNum / 2; rowNum < this.props.lineNum; rowNum++) {
        for (let colNum = this.props.columnNum / 2; colNum < this.props.columnNum; colNum++) {
          const positionStr = String(Number(rowNum + 1)) + '-' + String(Number(colNum + 1))
          rightPositionList.push(positionStr)
        }
      }
      for (let i1 = 0; i1 < obsNums.length; i1++) { // 観察項目ごとに繰り返し
        resultHumanTmp[i1].result_score = {
          left: { mode: '', mean: '' },
          top: { mode: '', mean: '' },
          right: { mode: '', mean: '' }
        };
      }

      // 天端のリストを作成
      const additionalTopScoreTmp: number[] = []
      const additionalLeftScoreTmp: number[] = []
      const additionalRightScoreTmp: number[] = []
      for (let i1 = 0; i1 < obsNums.length; i1++) {
        let topModeScore = 0
        let leftModeScore = 0
        let rightModeScore = 0
        // 天端
        const topPositionScoreList: number[] = []
        for (const topPosition of topPositionList) {
          for (const score of this.state.observationsScores[i1].scores) {
            if (score.position === topPosition) {
              topPositionScoreList.push(parseInt(score.score, 10))
            }
          }
        }
        resultHumanTmp[i1].result_score.top.mean = String(Math.round(10 * this.getMean(topPositionScoreList)) / 10)
        if (this.props.targetStepRuleObservationNames && this.props.targetStepRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // ステップルール
          topModeScore = this.getStepRuleScore(topPositionScoreList, this.props.topBadsideSize)
        }else if (this.props.targetModeRuleObservationNames && this.props.targetModeRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 最頻値ルール
          topModeScore = this.getMode(topPositionScoreList)
        }else if (this.props.targetMeanDeduplicationRuleObservationNames && this.props.targetMeanDeduplicationRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<スコア重複排除前提>ルール
          topModeScore = this.getMeanDeduplicationRuleScore(topPositionScoreList)
        }else if (this.props.targetMeanGeneralRuleObservationNames && this.props.targetMeanGeneralRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<一般>ルール
          topModeScore = this.getMeanGeneralRuleScore(topPositionScoreList)
        }else{
          topModeScore = this.getMode(topPositionScoreList)
        }
        resultHumanTmp[i1].result_score.top.mode = String(topModeScore)
        additionalTopScoreTmp.push(resultHumanTmp[i1].weight * topModeScore / 100)
        // 左肩
        const leftPositionScoreList: number[] = []
        for (const leftPosition of leftPositionList) {
          for (const score of this.state.observationsScores[i1].scores) {
            if (score.position === leftPosition) {
              leftPositionScoreList.push(parseInt(score.score, 10))
            }
          }
        }
        resultHumanTmp[i1].result_score.left.mean = String(Math.round(10 * this.getMean(leftPositionScoreList)) / 10)
        if (this.props.targetStepRuleObservationNames && this.props.targetStepRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // ステップルール
          leftModeScore = this.getStepRuleScore(leftPositionScoreList, this.props.leftBadsideSize)
        }else if (this.props.targetModeRuleObservationNames && this.props.targetModeRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 最頻値ルール
          leftModeScore = this.getMode(leftPositionScoreList)
        }else if (this.props.targetMeanDeduplicationRuleObservationNames && this.props.targetMeanDeduplicationRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<スコア重複排除前提>ルール
          leftModeScore = this.getMeanDeduplicationRuleScore(leftPositionScoreList)
        }else if (this.props.targetMeanGeneralRuleObservationNames && this.props.targetMeanGeneralRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<一般>ルール
          leftModeScore = this.getMeanGeneralRuleScore(leftPositionScoreList)
        }else{
          leftModeScore = this.getMode(leftPositionScoreList)
        }
        resultHumanTmp[i1].result_score.left.mode = String(leftModeScore)
        additionalLeftScoreTmp.push(resultHumanTmp[i1].weight * leftModeScore / 100)

        // 右肩
        const rightPositionScoreList: number[] = []
        for (const rightPosition of rightPositionList) {
          for (const score of this.state.observationsScores[i1].scores) {
            if (score.position === rightPosition) {
              rightPositionScoreList.push(parseInt(score.score, 10))
            }
          }
        }
        resultHumanTmp[i1].result_score.right.mean = String(Math.round(10 * this.getMean(rightPositionScoreList)) / 10)
        if (this.props.targetStepRuleObservationNames && this.props.targetStepRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // ステップルール
          rightModeScore = this.getStepRuleScore(rightPositionScoreList, this.props.rightBadsideSize)
        }else if (this.props.targetModeRuleObservationNames && this.props.targetModeRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 最頻値ルール
          rightModeScore = this.getMode(rightPositionScoreList)
        }else if (this.props.targetMeanDeduplicationRuleObservationNames && this.props.targetMeanDeduplicationRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<スコア重複排除前提>ルール
          rightModeScore = this.getMeanDeduplicationRuleScore(rightPositionScoreList)
        }else if (this.props.targetMeanGeneralRuleObservationNames && this.props.targetMeanGeneralRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<一般>ルール
          rightModeScore = this.getMeanGeneralRuleScore(rightPositionScoreList)
        }else{
          rightModeScore = this.getMode(rightPositionScoreList)
        }
        resultHumanTmp[i1].result_score.right.mode = String(rightModeScore)
        additionalRightScoreTmp.push(resultHumanTmp[i1].weight * rightModeScore / 100)
      }
      // 左肩、天端、右肩ごとのスコアを算出
      const additionalTopScore = Math.round(10 * this.getSum(additionalTopScoreTmp)) / 10
      const additionalLeftScore = Math.round(10 * this.getSum(additionalLeftScoreTmp)) / 10
      const additionalRightScore = Math.round(10 * this.getSum(additionalRightScoreTmp)) / 10
      const finallyScore = Math.round(10 * this.getSum([additionalTopScore * 2 , additionalLeftScore , additionalRightScore]) / 4) / 10

      this.setState({
        resultHuman: resultHumanTmp,
        additionalResultHuman: {
          each_position_score: { left: additionalLeftScore, top: additionalTopScore, right: additionalRightScore },
          each_position_weight: { left: 1, top: 2, right: 1 },
          finally_score: finallyScore
        }
      });
    }
  };
  /**
   * 外部から値を取得する
   */
  get() {
    return {
      ...this.state
    };
  }

  calcImgZoom() {
    const obsNum = this.props.result.length
    let yokoImgNum = 0
    if (obsNum <= 4) {
      yokoImgNum = 2
    } else if (obsNum <= 6) {
      yokoImgNum = 3
    } else if (obsNum <= 12) {
      yokoImgNum = 4
    } else {
      yokoImgNum = 5
    }
    let zoom = 0
    if (yokoImgNum === 2) {
      zoom = Math.round(((1024 - 100 - 50 * 2 - 10 * (2 + yokoImgNum - 1)) * 100 / yokoImgNum) / this.props.cropImageWidth)  // 1024pxはA4の横幅px 50px両側マージンを考慮する -100 は微調整
    } else {
      zoom = Math.round(((1024 - 50 * 2 - 10 * (2 + yokoImgNum - 1)) * 100 / yokoImgNum) / this.props.cropImageWidth)  // 1024pxはA4の横幅px 50px両側マージンを考慮する
    }
    console.log(zoom)
    return String(zoom) + '%'
  }

  render() {
    // if (!this.props.result || !(this.props.result.length > 0)) {
    if (false) {
      return (<Typography variant="body2">データ無し</Typography>);
    } else {
      // 人判断 追加評価情報
      const additionalLeftHuman = (this.state.additionalResultHuman.each_position_score || {}).left;
      const additionalTopHuman = (this.state.additionalResultHuman.each_position_score || {}).top;
      const additionalRightHuman = (this.state.additionalResultHuman.each_position_score || {}).right;
      const finallyScoreHuman = this.state.additionalResultHuman.finally_score;
      return (
        <div style={this.props.isPrint ? { width: '100%', display: 'flex', flexWrap: 'wrap', margin: '10px', breakBefore: 'page' } : {}}>
          {
            this.props.hideImages ? null : this.props.observationNames.map((observationName, index) => {
              // const url = item.overlay_img_presigned_url;
              return (
                // <div key={`images_${index}`} style={ this.props.isPrint ? {pageBreakBefore: 'always', marginTop: '50px'}: {}}> // 1ページ1画像で改ページするスタイル
                <div key={`images_${index}`} style={this.props.isPrint ? { display: 'flex', flexDirection: 'column', margin: '10px', zoom: this.calcImgZoom() } : {}}>
                  <Typography variant="h6">{observationName}</Typography>
                  <Typography variant="h6">{this.props.observationDescriptions[index]}</Typography>
                  {(this.state.observationsScores[index]) ?
                    <div style={this.props.isPrint ? { width: this.props.cropImageWidth, display: 'flex', flexDirection: 'column' } : { width: this.props.cropImageWidth, marginTop: '10px', marginBottom: '10px' }}>
                      {this.renderScoreInputObservationArea(this.state.observationsScores[index], index)}
                    </div>
                    : null
                  }
                </div>
              );
            })
          }

          {
            this.props.isPrint ? null : <hr />
          }
          {
            this.props.hideTable
              ? null
              : (
                <div>
                  <br />
                  {
                    this.state.resultHuman.length === 0
                      ? null
                      : (
                        <div>
                          <Typography variant="h6">総合評価</Typography>
                          <table style={{ width: '100%', borderCollapse: 'collapse' }} className="inferenceresulttable">
                            <thead>
                              <tr>
                                <th>観察項目</th>
                                <th style={{ width: '90px' }}>重み係数</th>
                                <th style={{ width: '90px' }}>左肩</th>
                                <th style={{ width: '90px' }}>天端</th>
                                <th style={{ width: '90px' }}>右肩</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                this.state.resultHuman.map((item, index) => {
                                  const scoreLeft = (item.result_score && item.result_score.left)
                                  // ? `${item.result_score.left.mode}（${item.result_score.left.mean}）` : '';
                                  ? `${item.result_score.left.mode}` : '';
                                  const scoreTop = (item.result_score && item.result_score.top)
                                  // ? `${item.result_score.top.mode}（${item.result_score.top.mean}）` : '';
                                  ? `${item.result_score.top.mode}` : '';
                                  const scoreRight = (item.result_score && item.result_score.right)
                                  // ? `${item.result_score.right.mode}（${item.result_score.right.mean}）` : '';
                                  ? `${item.result_score.right.mode}` : '';
                                  return (<tr key={`item_${index}`} className={(index % 2 === 0) ? 'even' : ''}>
                                    <td>{item.observation_name}</td>
                                    <td style={{ textAlign: 'center' }}>{item.weight}</td>
                                    <td style={{ textAlign: 'center' }}>{scoreLeft}</td>
                                    <td style={{ textAlign: 'center' }}>{scoreTop}</td>
                                    <td style={{ textAlign: 'center' }}>{scoreRight}</td>
                                  </tr>);
                                })
                              }
                              <tr style={{ borderTop: 'solid 3px black' }}>
                                <th colSpan={2} style={{ textAlign: 'right' }}>左肩、天端、右肩の総合評価点</th>
                                <td style={{ textAlign: 'center' }}>{additionalLeftHuman}</td>
                                <td style={{ textAlign: 'center' }}>{additionalTopHuman}</td>
                                <td style={{ textAlign: 'center' }}>{additionalRightHuman}</td>
                              </tr>
                              <tr>
                                <th colSpan={2} style={{ textAlign: 'right' }}>切羽全体の評価点</th>
                                <td style={{ textAlign: 'center' }} colSpan={3}>{finallyScoreHuman}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )
                  }
                </div>
              )
          }
        </div >
      );
    }
  }

  renderScoreInputObservationArea(item, obsIndex) { // 観察項目とその配下のスコアを描写
    type posScoreType = {
      position: string,
      score: string
    }
    const arrList: posScoreType[][] = []
    let idx = 0;
    while (idx < item.scores.length) {
      arrList.push(item.scores.slice(idx, idx + this.props.columnNum));
      idx = idx + this.props.columnNum;
    }
    return (
      <div key={`observation_${obsIndex}`}>
        <Table style={{ width: '100%' }}>
          <TableBody>
            {arrList.map((scoreRow, rowIndex) => this.renderScoreInputRowArea({ scoreRow, rowIndex, obsIndex }))}
          </TableBody>
        </Table>
      </div>
    );
  }
  renderScoreInputRowArea({ scoreRow, rowIndex, obsIndex }) {
    return (
      <TableRow key={`row_info_${obsIndex}_${rowIndex}`} style={{ margin: '0px' }}>
        {scoreRow.map((score, scoreIndex) => this.renderScoreInputArea({ score, scoreIndex, rowIndex, obsIndex }))}
      </TableRow>
    )
  }
  renderScoreInputArea({ score, scoreIndex, rowIndex, obsIndex }) {
    const handleChange = () => {
      // 配列を複製する
      const scorIndex = rowIndex * this.props.columnNum + scoreIndex;
      const inputs = this.state.observationsScores.slice();
      inputs[obsIndex].scores[scorIndex].score = String(Number(inputs[obsIndex].scores[scorIndex].score) + 1);
      if (Number(inputs[obsIndex].scores[scorIndex].score) > 6) {
        inputs[obsIndex].scores[scorIndex].score = '0';
      }
      this.setState({ observationsScores: inputs });
      if (this.state.observationsScores.length !== 0) {
        this.changeComprehensiveEvaluationTable()
      }
    }
    const styleButton = { padding: '0px', minWidth: '30px', minHeight: '15px', marginLeft: '5px' }
    return (
      <TableCell key={`score_info_${obsIndex}_${rowIndex}_${scoreIndex}`} style={(obsIndex % 2 === 0) ? styles.rowDark : styles.rowLight}>
        <span style={{ marginTop: '2px' }}>
          {score.position}:
        </span>
        <Button variant="contained" onClick={handleChange} style={styleButton} color={"default"}>
          {score.score}
        </Button>
      </TableCell>
    );
  }

}
export default KansatsuKirokuScoreEditForObsrec;



// WEBPACK FOOTER //
// ./src/components/parts/KansatsuKirokuScoreEditForObsrec.tsx